<template>
  <div>
    <v-alert v-if="!usuarioLogado.adminWeb" type="warning" outlined dense class="mb-4">
      Acesso restrito: faça login como administrador para configurar questionários.
    </v-alert>
    <v-container v-else fluid class="questionario-container">
      <v-row justify="center" c>
        <v-col cols="12">
          <v-card class="pa-5 questionario-card">
            <v-card-title class="font-weight-bold d-flex align-center">
              <v-btn
                outlined
                color="grey lighten-1"
                class="mr-4"
                @click="voltarSelecionarInstrumento"
                title="Voltar para configuração de questionário"
              >
                <v-icon size="20">mdi-arrow-left</v-icon>
                <span class="ml-2" style="font-size: 10px">Voltar</span>
              </v-btn>
              Configurar Questionário
            </v-card-title>
            <div class="questionario-acoes">
              <v-icon></v-icon>
              <v-btn color="success" block @click="novoQuestionario">Novo Questionário</v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12">
          <v-card class="mt-6" elevation="2" v-if="listQuestionario && listQuestionario.length">
            <v-card-title class="font-weight-bold">Questionários do Ano {{ ano }}</v-card-title>
            <v-card-text>
              <div class="questionario-grid">
                <v-card v-for="q in listQuestionario" :key="q.id" outlined class="questionario-item-card">
                  <v-card-text class="questionario-item-card__content">
                    <div class="questionario-item-card__titulo">
                      {{ q.anexo || q.nome || q.titulo || "Sem título" }}
                    </div>
                    <div class="questionario-item-card__meta">ID: {{ q.id }}</div>
                    <div v-if="q.instrumento" class="questionario-item-card__meta">
                      Instrumento: {{ q.instrumento }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="questionario-item-card__actions">
                    <v-icon
                      class="questionario-item-card__action-icon mr-1"
                      color="primary"
                      title="Editar Questionário"
                      @click="editarQuestionario(q)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      class="questionario-item-card__action-icon mr-1"
                      color="info"
                      title="Editar Questões"
                      @click="editarQuestoes(q)"
                    >
                      mdi-format-list-bulleted
                    </v-icon>
                    <v-icon
                      class="questionario-item-card__action-icon"
                      color="pink"
                      title="Clonar Questionário"
                      @click="clonarQuestionario(q)"
                    >
                      mdi-content-copy
                    </v-icon>
                  </v-card-actions>
                </v-card>
              </div>
            </v-card-text>
          </v-card>

          <v-card v-if="!listQuestionario || !listQuestionario.length">
            <v-alert type="info" text border="left" colored-border color="indigo" class="mb-0">
              Nenhum questionário encontrado para o ano selecionado.
            </v-alert>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="loading" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text class="text-center">
          <v-progress-circular indeterminate color="white"></v-progress-circular>
          <div class="mt-3">Carregando...</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalClonar" persistent max-width="400">
      <v-card color="white" class="pa-4">
        <v-card-text class="text-center">
          <div class="mb-3">Digite o ano para o qual deseja clonar o questionário:</div>
          <v-text-field
            v-model="anoDestino"
            label="Ano Destino"
            type="number"
            min="2000"
            max="2100"
            outlined
            dense
          ></v-text-field>
          <v-btn color="white" @click="confirmarClonar" :disabled="!anoDestino">Confirmar</v-btn>
          <v-btn text @click="modalClonar = false">Cancelar</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="4000" top>
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import QuestionariosServices from "@/services/ava/QuestionariosServices";
export default {
  name: "ConfigurarQuestionario",
  data() {
    return {
      questionarios: this.listQuestionario || [],
      loading: false,
      modalClonar: false,
      anoDestino: null,
      dadosClonar: {},
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
    };
  },
  computed: {
    ...mapGetters({
      anoSelecionado: "avaliacao/anoSelecionado",
      listQuestionario: "avaliacao/getListaQuestionariosInstrumento",
      usuarioLogado: "config/getUsuarioLogado",
      instrumentoSelecionado: "avaliacao/getInstrumentoSelecionado",
      cardapioSelecionado: "avaliacao/selecionado",
    }),
    idInstrumentoSelecionado() {
      return this.instrumentoSelecionado ? this.instrumentoSelecionado.id : null;
    },
    ano: {
      get() {
        return this.anoSelecionado;
      },
      set(value) {
        this.setAnoSelecionado(value);
      },
    },
  },
  mounted() {
    if (!this.idInstrumentoSelecionado || !this.anoSelecionado) {
      this.$router.push({ name: "SelecionarInstrumentoQuestionario" });
    }
  },
  methods: {
    ...mapActions({}),
    ...mapMutations({
      setAnoSelecionado: "avaliacao/setAnoSelecionado",
      setSelecionado: "avaliacao/setSelecionado",
    }),
    voltarSelecionarInstrumento() {
      this.$router.push({ name: "SelecionarInstrumentoQuestionario" });
    },
    editarQuestionario(q) {
      this.setSelecionado(q);
      this.$router.push({ name: "EditorQuestionario" });
    },
    editarQuestoes(q) {
      this.setSelecionado(q);
      this.$router.push({ name: "EditorQuestoes" });
    },
    novoQuestionario() {
      this.setSelecionado({
        id: null,
        id_instrumento: null,
        instrumento: "",
        anexo: "",
        ano: this.ano,
        status: null,
        id_publico: null,
        grupo_resposta: "",
      });
      this.$router.push({ name: "EditorQuestionario" });
    },

    clonarQuestionario(q) {
      this.setSelecionado(q);
      this.modalClonar = true;
      this.dadosClonar = {};
      this.dadosClonar = { ...this.cardapioSelecionado };
    },
    async confirmarClonar() {
      this.loading = true;
      try {
        this.dadosClonar.ano = this.anoDestino;
        const data = await QuestionariosServices.clonarQuestionario(this.dadosClonar);

        if (data?.success) {
          const novoId = data?.data?.id;
          this.snackbarText = novoId ? `Questionário clonado com sucesso! Novo ID: ${novoId}` : data.success;
          this.snackbarColor = "success";
          this.modalClonar = false;
          this.anoDestino = null;
        } else {
          this.snackbarText = "A clonagem não retornou confirmação de sucesso.";
          this.snackbarColor = "warning";
        }
      } catch (error) {
        this.snackbarText = error?.response?.data?.error || error?.message || "Erro ao clonar questionário.";
        this.snackbarColor = "error";
      } finally {
        this.snackbar = true;
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.questionario-container {
  padding: 16px;
}

.questionario-card {
  width: 100%;
}

.questionario-grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 16px;
}

.questionario-item-card {
  width: 100%;
}

.questionario-item-card__content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.questionario-item-card__titulo {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.4;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.questionario-item-card__meta {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.4;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.questionario-item-card__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
  min-height: 48px;
}

.questionario-item-card__action-icon {
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
}

.questionario-acoes {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

.questionario-acoes :deep(.v-btn) {
  width: 100%;
  max-width: 100%;
  padding-left: 12px;
  padding-right: 12px;
  white-space: normal;
  word-break: break-word;
  line-height: 1.2;
  min-height: 42px;
  height: auto;
}

.questionario-acoes :deep(.v-btn__content) {
  display: block;
  width: 100%;
  white-space: normal;
  word-break: break-word;
  text-align: center;
  line-height: 1.2;
}

@media (min-width: 1264px) {
  .questionario-container {
    padding-left: 40px;
    padding-right: 40px;
  }

  .questionario-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 760px) and (max-width: 1263px) {
  .questionario-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .questionario-card {
    padding: 16px !important;
  }

  .questionario-grid {
    grid-template-columns: 1fr;
  }
}
</style>
